export default __webpack_public_path__ + "static/blank_phone-76d4ca4be53c2d63e9ca3c6e68cb273f.png";